// source: design/src/pages/SIPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
export default {
  common: {
    coreModules: '核心功能模块',
    coreModulesEN: 'Core Functional Modules',
    scenarios: '应用场景',
    scenariosEn: 'Use Cases',
    benefits: '使用核心系统的显著收益',
    benefitsEn: 'Significant benefits of using the core system',
    cta: '欢迎了解更多飞狼业务',
    learnMore: '了解详情',
    breadcrumb: {
      home: '首页',
      products: '产品与服务',
      si: 'SI 系统集成',
    },
  },
  heroTitle: 'SI 系统集成',
  heroSubtitle: 'System Integration',
  heroDesc: '围绕企业实际业务需求，整合MES、WMS、AI等系统与技术，打通业务流程与数据，实现不同系统之间的高效协同，构建统一、灵活的数字化管理体系。',
  intro: [
    '从企业实际业务场景出发，提供涵盖系统规划、设计、开发、集成与实施的综合解决方案。',
    '通过整合制造执行系统（MES）、仓储管理系统（WMS）及AI等不同系统与技术，连接生产、仓储、物流、设备及管理等业务环节，打通企业内部数据与业务流程，实现不同系统之间的信息共享与协同运作。',
    '根据企业现有IT环境与业务需求进行灵活整合，帮助企业减少系统之间的信息孤岛，优化业务流程，提升生产与运营效率，并逐步构建可持续扩展的数字化基础。',
  ],
  solutionsTitle: '解决方案',
  solutionsSubtitle: 'Our Solutions',
  solutions: [
    {
      icon: 'si/si-icons/factory.svg',
      title: '制造执行系统 (MES)',
      desc: '连接ERP计划层与车间执行层，实现生产调度、质量管控、设备集成的实时可视化，打通智能制造的最后一公里。',
      routeName: 'si-mes',
    },
    {
      icon: 'si/si-icons/warehouse.svg',
      title: '仓储管理系统 (WMS)',
      desc: '优化入库、库位、拣货、出库全流程管理，实现库存实时可视化与波次智能规划，提升仓储运营效率与准确率。',
      routeName: 'si-wms',
    },
    {
      icon: 'si/si-icons/brain.svg',
      title: 'AI',
      desc: '整合工单管理、人员调度、现场作业、设备维护等业务流程，实现服务资源统一管理与实时协同，提升现场服务效率与客户满意度。',
      routeName: 'si-ai',
    },
  ],
  contact: '联系我们',
};
